import React, {useEffect, useState, useRef} from 'react';
import * as R from 'ramda';
import countryTelData from 'country-telephone-data';
import parsePhoneNumber from 'libphonenumber-js';
import { useHistory, useLocation } from 'react-router-dom';

import {GenerateOtpCode} from '../../../../actions/auth/partnersInvitation';


export const PartnerInvitationStep0 = ({user, setUser, timestamp, nonce, signature}) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    const history = useHistory();
    const location = useLocation();

    const formRef = useRef();
    let phone = {
        nationalNumber: '',
        countryCallingCode: '',
        country: ''
    };
    if(!R.isNil(user) && !R.isNil(user.phoneNumber)){
        phone = parsePhoneNumber(user.phoneNumber);
    }
    const [loading, setLoading] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState({
        phoneNumber: phone?.nationalNumber,
        countryCode: phone?.countryCallingCode,
        phoneCountry: phone?.country
    });

    useEffect(() => {
        if(!R.isNil(user) && !R.isNil(user.phoneNumber)){
            const phone = parsePhoneNumber(user.phoneNumber);
            setPhoneNumber({
                phoneNumber: phone?.nationalNumber,
                countryCode: phone?.countryCallingCode,
                phoneCountry: phone?.country
            });
        }
    }, [user])

    useEffect(() => {
        const parsedPhoneNumber = parsePhoneNumber(phoneNumber.phoneNumber, phoneNumber.phoneCountry);
        if(!R.isNil(parsedPhoneNumber) && parsedPhoneNumber.isValid() && user.phoneNumber !== parsedPhoneNumber.number){
            setUser({...user, phoneNumber: parsedPhoneNumber.number});
        }
    }, [phoneNumber])
    
    return (
        <>
        <form className="container-xl-base py-2 mb-auto" noValidate ref={formRef}>
            <h1 className="h1 text-primary font-weight-bolder mb-6">Activation de votre compte</h1>
            <div className="form-group container-copy">
                <label className="h6 font-weight-bolder lh-root" htmlFor="telephone">Veuillez confirmer votre numéro de téléphone:</label>
                <div className="input-group has-validation mb-0">
                    <select className="custom-select rounded container-paper container-sm-tiny mr-2" id="naturalite" tabIndex={-98} value={phoneNumber.countryCode} onChange={(event) => {
                        let pc = countryTelData.allCountryCodes[event.target.value][0].toUpperCase();
                        setPhoneNumber({ ...phoneNumber, countryCode: event.target.value, phoneCountry: pc });
                    }}>
                    {
                        countryTelData.allCountries.map((country, index) => {
                            let dialCode = country.dialCode;
                            return (
                                <option key={index} value={dialCode}>{countries.getName(country.iso2, "fr", {select: "official"})} (+{dialCode})</option>
                            );
                        })
                    }
                    </select>
                    <input required type="tel" className="form-control rounded" id="phoneNumberInput" placeholder="00 00 00 00 00" 
                        value={parsePhoneNumber(phoneNumber.phoneNumber, phoneNumber.phoneCountry) !== undefined ? parsePhoneNumber(phoneNumber.phoneNumber, phoneNumber.phoneCountry).formatNational() : phoneNumber.phoneNumber} 
                        onChange={(e) => {setPhoneNumber({ ...phoneNumber, phoneNumber: e.target.value }); document.getElementById("phoneNumberInput").setCustomValidity("");}}
                    />
                    <div className="invalid-feedback">
                        <i className="eva eva-alert-triangle-outline text-danger mr-1 fs-sm lh-root align-middle"></i>
                        <span className="align-middle text-dark o-70" id="PhoneNumberInputValidation">Ce numéro n'est pas valide.</span>
                    </div>
                </div>
            </div>
        </form>
        <footer className="block mt-auto text-left w-100 rounded-inherit">
            {
                loading ?
                    <button type="button" className="btn btn-primary px-md-gutter px-4 loading-btn show"><div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Suivant</button>
                :
                    <button className="btn btn-primary px-md-gutter px-4" onClick={(e) =>{
                        const parsedPhoneNumber = parsePhoneNumber(phoneNumber.phoneNumber, phoneNumber.phoneCountry);
                        if(!parsedPhoneNumber.isValid()){
                            document.getElementById("phoneNumberInput").setCustomValidity("Le numéro de téléphone n'est pas valide.");
                        }
                        if(formRef.current.checkValidity()){
                            setLoading(true);
                            GenerateOtpCode(user.userId, timestamp, nonce, signature, user.phoneNumber)
                            .then(() => {
                                setLoading(false);
                                history.push(`/auth/partner/invitation/${user.userId}/activation/step1${location.search}`);
                                //setStep(step + 1);
                            });
                        }
                        formRef.current.classList.add('was-validated');
                    }}>Suivant</button>
            }
            
        </footer>
        </>
    )
}